const features = {
  ai: 'IA',
  featureAiDescription: 'Activer ou désactiver toutes les fonctionnalités d\'IA.',
  featureGithubDescription: 'Surveiller des dépôts GitHub.',
  featureKey: 'Clé',
  featureObjectivesDescription: 'Suivre les objectifs et leur avancement.',
  featureStravaDescription: 'Surveiller des athlètes Strava.',
  featureSubstackDescription: 'Surveiller des publications Substack.',
  features: 'Fonctionnalités',
  featuresIntro: 'Choisissez les parties de l\'application disponibles pour tout le monde.',
  featuresLoadFailed: 'Impossible de charger les fonctionnalités.',
  featureTasksDescription: 'Suivre le travail à faire.',
  featureTimesheetDescription: 'Enregistrer le temps passé dans la journée.',
  featureYoutubeDescription: 'Surveiller des chaînes YouTube.',
  featureUpdateFailed: 'Impossible de mettre à jour les fonctionnalités. Réessayez.',
};

export default features;
